import { trpc } from '@/data-loaders';

export const useCampusList = (year: number) => {
  return trpc.getCampusList.useQuery(
    { year },
    {
      retry: false,
      cacheTime: 1000 * 60 * 60 * 24, // 1 day
    },
  );
};
